var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topic-row topic-header"},[_c('div',{staticClass:"subscription-col topic-header-label",on:{"click":_vm.toggleOpen}},[_c('div',[_c('span',{class:_vm.caretObject}),_vm._v("\n      Topic Subscriptions\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }